module.exports = __webpack_public_path__ + "img/banner.8f3421f3.jpg";